import type { CancelToken, CancelTokenSource } from 'axios';
import Axios from 'axios';

const TIMEOUT_CANCEL_MESSAGE = 'timeout';

export class TimeLimit {
  private timeoutCts: CancelTokenSource;
  readonly token: CancelToken;
  pending: NodeJS.Timeout;
  constructor(readonly timeout: number) {
    this.timeoutCts = Axios.CancelToken.source();
    this.token = this.timeoutCts.token;
    this.pending = setTimeout(() => this.timeoutCts.cancel(TIMEOUT_CANCEL_MESSAGE), timeout);
  }

  close() {
    clearTimeout(this.pending);
  }
}

export function isTimeout(cause: any) {
  return Axios.isCancel(cause) && cause.message == TIMEOUT_CANCEL_MESSAGE;
}
